import { NgModule } from '@angular/core';
import { WholeNumberDirective } from './whole-number.directive';

@NgModule({
    declarations: [
        WholeNumberDirective
    ],
    exports: [
        WholeNumberDirective
    ]
})
export class WholeNumberDirectiveModule { }
